'use client'

import { useEffect, useRef } from 'react'
import { trackArticleView, whenGtagReady } from '@/lib/ga'

/**
 * Fires a single GA4 `article_view` when the article is shown.
 * Waits for deferred gtag bootstrap; does not write to our DB.
 */
export default function GaArticleTracker({
  articleId,
  title,
  category,
  path,
}: {
  articleId: number
  title: string
  category?: string | null
  path?: string
}) {
  const sent = useRef<number | null>(null)

  useEffect(() => {
    if (!articleId || !title) return
    if (sent.current === articleId) return

    const cancel = whenGtagReady(() => {
      if (sent.current === articleId) return
      sent.current = articleId
      trackArticleView({
        articleId,
        title,
        category,
        path:
          path ||
          (typeof window !== 'undefined' ? window.location.pathname : undefined),
      })
    })

    return cancel
  }, [articleId, title, category, path])

  return null
}
